import gql from 'graphql-tag';
export default gql`
  fragment salesReportInfo on SalesReport {
    orderedTotal
    orderedTotalWithPDV
    orderedCount
    deliveredTotal
    deliveredTotalWithPDV
    deliveredCount
  }
`;